import {LocaleType} from '../enum/LocaleType'

// Every LocaleType is a BCP 47 language subtag except Ukrainian: 'ua' is the country, the language is 'uk'
const languageTagByLocaleType: Partial<Record<LocaleType, string>> = {
  [LocaleType.Ukrainian]: 'uk',
}

/**
 * The BCP 47 language tag of an app language, for Intl (dates, times, numbers): the inverse of
 * resolveLocaleTypeFromLanguageTag. Intl given 'ua' falls back to its default language, so the dates of a Ukrainian
 * interface would come out in English. Any other value passes through.
 */
export function getLanguageTagFromLocaleType(localeType: LocaleType | string): string {
  return languageTagByLocaleType[localeType as LocaleType] ?? localeType
}
